/* ============================================================
   DATZZY — Shared chrome: header, cart, footer, interactions
   ============================================================ */
(function(){
  // Resolves to an inlined blob URL in standalone exports, else the real path.
  const RES=(id,f)=>(window.__resources&&window.__resources[id])||f;
  const LOGO_LIGHT = RES('logoLight','assets/logo-light.svg');
  const LOGO_DARK  = RES('logoDark','assets/logo-dark.svg');

  /* ============================================================
     Temporary pre-launch mode: store disabled until Shopify launch.
     ------------------------------------------------------------
     While PRELAUNCH is true the storefront presents products but no
     purchasing is possible: prices are hidden, the cart icon/drawer are
     removed, and every add-to-cart / checkout / shop CTA becomes a
     disabled "Sklep wkrótce" button. Shopify architecture, product data,
     routing and pages are untouched. To go live: set PRELAUNCH = false
     (nothing else needs reverting — all transforms are runtime-only). */
  const PRELAUNCH = false;
  window.DZ_PRELAUNCH = PRELAUNCH;
  const SOON_LABEL = 'Sklep wkrótce';

  // ---- Single source of truth (see catalog.js) ----
  // Product, variant, subscription and bundle data are defined ONCE in
  // catalog.js and exposed on window. The cart catalog and mega-menu are
  // derived there too. Defensive fallbacks keep tooling pages that omit
  // catalog.js from hard-crashing.
  const CATALOG = window.DZ_CATALOG || {};

  // ---- i18n helper (see locales.js) ----
  const T = window.DZ_T || (k=>k);

  const ICONS = {
    user:'<svg width="21" height="21" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><circle cx="12" cy="8" r="4"/><path d="M4 21c0-4 3.6-7 8-7s8 3 8 7"/></svg>',
    cart:'<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M3 5h2l2.2 11.2a1.6 1.6 0 0 0 1.6 1.3h8.7a1.6 1.6 0 0 0 1.6-1.2L21 8H6.2"/><circle cx="9.5" cy="20.5" r="1.3" fill="currentColor" stroke="none"/><circle cx="18" cy="20.5" r="1.3" fill="currentColor" stroke="none"/></svg>',
    close:'<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M6 6l12 12M18 6L6 18"/></svg>',
    arrow:'<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M5 12h14M13 6l6 6-6 6"/></svg>',
    menu:'<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7"><path d="M3 7h18M3 12h18M3 17h18"/></svg>'
  };

  // Mega-menu entries derived from the single source of truth (catalog.js).
  const MEGA = window.DZ_MEGA || [];
  const NAV = [
    {label:T('nav.products'), href:'produkty.html', mega:true},
    {label:T('nav.science'), href:'jak-to-dziala.html'},
    // Edukacja temporarily hidden from public navigation (page kept for future reuse).
    {label:T('nav.about'), href:'o-nas.html'},
    {label:T('nav.work'), href:'wspolpraca.html'},
    {label:T('nav.faq'), href:'index.html#faq'}
  ];

  // ---- Cart ----
  // Cart is fully owned by the Shopify cart controller (assets/dz-cart.js →
  // window.dzCart). Shopify /cart.js is the single source of truth. The old
  // localStorage prototype (getCart/setCart/dzAddToCart + localStorage-based
  // updateCount) has been removed — no client-side cart state here, and the
  // header [data-cart-count] is updated only by window.dzCart.

  // ---- Header ----
  // Stage 2.2 (Shopify): the header + mobile menu are rendered server-side by the
  // Shopify header section. Bind the existing (approved-frontend) markup instead of
  // creating it — same handlers and behaviour as buildHeader's creation path below.
  // The mega grid + mobile sub-list are left empty by the section and filled here
  // from the catalog (products not yet migrated to Shopify).
  function wireExistingHeader(){
    const header = document.querySelector('.dz-nav');
    const menu   = document.querySelector('.dz-mobile-menu');
    if(!header) return;
    const mode = header.getAttribute('data-mode') || document.body.getAttribute('data-nav') || 'solid';

    const grid = header.querySelector('.dz-mega-grid');
    if(grid && !grid.children.length){
      grid.innerHTML = MEGA.map(p=>`<a class="dz-mega-card" href="${p.href}"><span class="dz-mega-thumb"><img data-src="${p.img}" alt="" loading="lazy" decoding="async"/></span><span class="dz-mega-meta"><b>${p.name}</b><span>${p.tag}</span></span></a>`).join('');
    }
    const sub = menu && menu.querySelector('.dz-mm-sub');
    if(sub && !sub.children.length){
      sub.innerHTML = MEGA.map(p=>`<a href="${p.href}">${p.name}</a>`).join('');
    }

    // scroll behaviour for transparent nav
    if(mode==='transparent'){
      const onScroll = ()=> header.classList.toggle('scrolled', window.scrollY>40);
      window.addEventListener('scroll', onScroll, {passive:true}); onScroll();
    } else { header.classList.add('scrolled'); }

    const cartBtn = header.querySelector('[data-open-cart]');
    if(cartBtn) cartBtn.addEventListener('click', openCart);

    const burger = header.querySelector('[data-open-menu]');
    if(burger && menu){
      burger.setAttribute('aria-expanded','false');
      burger.setAttribute('aria-haspopup','dialog');
      menu.setAttribute('role','dialog');
      menu.setAttribute('aria-modal','true');
      menu.setAttribute('aria-label', T('nav.menu'));
      /* The burger is the only toggle: it stays in the nav row and morphs into an X
         (body.menu-open drives the animation), so opening and closing happen in the
         same spot. Any [data-close-menu] control still works if a theme adds one. */
      burger.addEventListener('click', ()=>{
        if(document.body.classList.contains('menu-open')){ closeMenu(); return; }
        /* While the cart is open the burger shows an X and closes the cart, so the
           same control in the same spot dismisses whichever panel is open. */
        if(document.body.classList.contains('cart-open')){
          if(window.dzCart && window.dzCart.close) window.dzCart.close();
          return;
        }
        menu.classList.add('open');
        document.body.classList.add('menu-open');
        document.body.style.overflow='hidden';
        burger.setAttribute('aria-expanded','true');
        /* Focus the dialog itself, not the first link: focusing the link painted a
           focus ring around "Produkty" the moment the menu opened. */
        menu.setAttribute('tabindex','-1');
        menu.focus({preventScroll:true});
      });
      const closeBtn = menu.querySelector('[data-close-menu]');
      if(closeBtn) closeBtn.addEventListener('click', closeMenu);
      menu.addEventListener('keydown', e=>{ if(e.key==='Escape'){ e.stopPropagation(); closeMenu(); } });
      menu.querySelectorAll('.dz-mm-nav a').forEach(a=>a.addEventListener('click',closeMenu));
    }

    const megaItem = header.querySelector('.dz-has-mega');
    if(megaItem){
      let megaImgsLoaded = false;
      const loadMegaImgs = ()=>{
        if(megaImgsLoaded) return; megaImgsLoaded = true;
        megaItem.querySelectorAll('img[data-src]').forEach(im=>{ im.src = im.dataset.src; im.removeAttribute('data-src'); });
      };
      megaItem.addEventListener('mouseenter', loadMegaImgs, {once:true, passive:true});
      megaItem.addEventListener('focusin', loadMegaImgs, {once:true});
      const trig = megaItem.querySelector('.dz-navlink');
      const setExp = v => trig && trig.setAttribute('aria-expanded', v?'true':'false');
      megaItem.addEventListener('focusin', ()=>setExp(true));
      megaItem.addEventListener('focusout', e=>{ if(!megaItem.contains(e.relatedTarget)) setExp(false); });
      megaItem.addEventListener('mouseenter', ()=>setExp(true));
      megaItem.addEventListener('mouseleave', ()=>setExp(false));
    }

    document.querySelectorAll('[data-lang]:not([disabled])').forEach(b=>b.addEventListener('click',()=>{
      const mk = (b.getAttribute('data-lang')||'pl').toLowerCase();
      if(mk === (window.DZ_MARKET||'pl')){ closeMenu(); return; }
      try{ localStorage.setItem('dz_market', mk); }catch(e){}
      location.reload();
    }));
    const curMk = (window.DZ_MARKET||'pl').toUpperCase();
    document.querySelectorAll('[data-lang-label]').forEach(x=>x.textContent=curMk);
  }

  function buildHeader(){
    // Prefer the server-rendered Shopify header section when present.
    if(document.querySelector('.dz-nav')){ wireExistingHeader(); return; }
    const mode = document.body.getAttribute('data-nav')||'solid'; // 'transparent' | 'solid'
    const header = document.createElement('header');
    header.className = 'dz-nav';
    header.setAttribute('data-mode', mode);
    header.innerHTML = `
      <div class="dz-nav-inner wrap">
        <a class="dz-logo" href="index.html" aria-label="DATZZY home">
          <img class="logo-l" src="${LOGO_LIGHT}" alt="DATZZY" decoding="async"/>
          <img class="logo-d" src="${LOGO_DARK}" alt="DATZZY" decoding="async"/>
        </a>
        <nav class="dz-mainnav">
          ${NAV.map(n=> n.mega ? `
            <div class="dz-navitem dz-has-mega">
              <a href="${n.href}" class="dz-navlink" aria-haspopup="true" aria-expanded="false" aria-controls="dz-mega-panel">${n.label}<svg class="dz-caret" width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" aria-hidden="true"><path d="M6 9l6 6 6-6"/></svg></a>
              <div class="dz-mega" id="dz-mega-panel">
                <div class="dz-mega-inner card">
                  <div class="dz-mega-grid">
                    ${MEGA.map(p=>`<a class="dz-mega-card" href="${p.href}"><span class="dz-mega-thumb"><img data-src="${p.img}" alt="" loading="lazy" decoding="async"/></span><span class="dz-mega-meta"><b>${p.name}</b><span>${p.tag}</span></span></a>`).join('')}
                  </div>
                  <a class="dz-mega-all" href="produkty.html">${T('nav.viewAll')} ${ICONS.arrow}</a>
                </div>
              </div>
            </div>` : `<a class="dz-navlink" href="${n.href}">${n.label}</a>`).join('')}
        </nav>
        <div class="dz-nav-right">
          <div class="dz-lang">
            <button class="dz-lang-btn" aria-haspopup="true"><span data-lang-label>PL</span>
              <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4"><path d="M6 9l6 6 6-6"/></svg>
            </button>
            <div class="dz-lang-menu">
              <button data-lang="PL">Polski</button>
              <button data-lang="DE" disabled aria-disabled="true" title="Wersja niemiecka wkrótce">Deutsch</button>
            </div>
          </div>
          ${PRELAUNCH
            ? `<button class="dz-ic dz-ic-soon" type="button" aria-label="${T('nav.account')}" aria-disabled="true" disabled title="${SOON_LABEL}">${ICONS.user}</button>`
            : `<a href="/account" class="dz-ic" rel="nofollow" aria-label="${T('nav.account')}">${ICONS.user}</a>`}
          ${PRELAUNCH
            /* Temporary pre-launch mode: cart icon hidden, shop CTA disabled ("Sklep wkrótce"). */
            ? `<button class="btn dz-shop dz-soon" type="button" aria-disabled="true" disabled>${SOON_LABEL}</button>`
            : `<button class="dz-ic dz-cart-btn" aria-label="${T('nav.cart')}" data-open-cart>${ICONS.cart}<span class="dz-cart-count" data-cart-count></span></button>
          <a href="produkty.html" class="btn btn-primary dz-shop">${T('nav.shopNow')}</a>`}
          <button class="dz-ic dz-burger" aria-label="${T('nav.menu')}" data-open-menu>${ICONS.menu}</button>
        </div>
      </div>`;
    document.body.prepend(header);

    // Skip link — visually hidden until focused (styles in chrome.css).
    // Inserted before the header so it is the first focusable element.
    if(!document.querySelector('.dz-skip')){
      const skip = document.createElement('a');
      skip.className = 'dz-skip';
      skip.href = '#dz-main';
      skip.textContent = T('a11y.skip');
      document.body.prepend(skip);
    }

    // mobile menu
    const menu = document.createElement('div');
    menu.className = 'dz-mobile-menu';
    menu.innerHTML = `
      <div class="dz-mm-head wrap">
        <img src="${LOGO_DARK}" class="dz-mm-logo" alt="DATZZY" loading="lazy" decoding="async"/>
        <button class="dz-ic" data-close-menu aria-label="${T('nav.close')}">${ICONS.close}</button>
      </div>
      <nav class="dz-mm-nav">
        <a href="produkty.html">${T('nav.products')}<span>${ICONS.arrow}</span></a>
        <div class="dz-mm-sub">
          ${MEGA.map(p=>`<a href="${p.href}">${p.name}</a>`).join('')}
        </div>
        <a href="jak-to-dziala.html">${T('nav.science')}<span>${ICONS.arrow}</span></a>
        <a href="o-nas.html">${T('nav.about')}<span>${ICONS.arrow}</span></a>
        <a href="wspolpraca.html">${T('nav.work')}<span>${ICONS.arrow}</span></a>
        <a href="index.html#faq">${T('nav.faq')}<span>${ICONS.arrow}</span></a>
      </nav>
      <div class="dz-mm-foot">
        ${PRELAUNCH
          /* Temporary pre-launch mode: mobile shop CTA disabled ("Sklep wkrótce"). */
          ? `<button class="btn dz-soon btn-block btn-lg" type="button" aria-disabled="true" disabled>${SOON_LABEL}</button>`
          : `<a href="produkty.html" class="btn btn-primary btn-block btn-lg">${T('nav.shopSystem')}</a>`}
        <div class="dz-mm-lang"><span>${T('nav.language')}</span><div><button data-lang="PL">PL</button><button data-lang="DE" disabled aria-disabled="true" title="Wersja niemiecka wkrótce">DE</button></div></div>
      </div>`;
    document.body.appendChild(menu);

    // scroll behaviour for transparent nav
    if(mode==='transparent'){
      const onScroll = ()=> header.classList.toggle('scrolled', window.scrollY>40);
      window.addEventListener('scroll', onScroll, {passive:true}); onScroll();
    } else { header.classList.add('scrolled'); }

    // Cart trigger is absent in pre-launch mode (cart icon hidden).
    const cartBtn = header.querySelector('[data-open-cart]');
    if(cartBtn) cartBtn.addEventListener('click', openCart);
    // The mobile menu is an opaque full-screen overlay (position:fixed; inset:0) but
    // sits LAST in the DOM, so tab order used to walk the entire page behind it —
    // a keyboard user tabbed through content they cannot see (WCAG 2.4.3 Focus Order).
    // Moving focus into the panel on open, and back to the burger on close, keeps the
    // keyboard where the eye is. Escape closes, as expected of any dialog.
    const burger = header.querySelector('[data-open-menu]');
    burger.setAttribute('aria-expanded','false');
    burger.setAttribute('aria-haspopup','dialog');
    menu.setAttribute('role','dialog');
    menu.setAttribute('aria-modal','true');
    menu.setAttribute('aria-label', T('nav.menu'));
    burger.addEventListener('click', ()=>{
      menu.classList.add('open');
      document.body.style.overflow='hidden';
      burger.setAttribute('aria-expanded','true');
      const first = menu.querySelector('[data-close-menu]');
      if(first) first.focus();
    });
    menu.querySelector('[data-close-menu]').addEventListener('click', closeMenu);
    menu.addEventListener('keydown', e=>{ if(e.key==='Escape'){ e.stopPropagation(); closeMenu(); } });
    menu.querySelectorAll('.dz-mm-nav a').forEach(a=>a.addEventListener('click',closeMenu));

    // Mega menu: reflect open state for assistive tech. The CSS opens the panel
    // on hover AND keyboard focus (:focus-within) — this only keeps aria-expanded
    // in sync; it adds no new visual state.
    const megaItem = header.querySelector('.dz-has-mega');
    if(megaItem){
      // Deferred mega-menu thumbnails: swap data-src -> src on first open only.
      let megaImgsLoaded = false;
      const loadMegaImgs = ()=>{
        if(megaImgsLoaded) return; megaImgsLoaded = true;
        megaItem.querySelectorAll('img[data-src]').forEach(im=>{
          im.src = im.dataset.src; im.removeAttribute('data-src');
        });
      };
      megaItem.addEventListener('mouseenter', loadMegaImgs, {once:true, passive:true});
      megaItem.addEventListener('focusin', loadMegaImgs, {once:true});
      const trig = megaItem.querySelector('.dz-navlink');
      const setExp = v => trig && trig.setAttribute('aria-expanded', v?'true':'false');
      megaItem.addEventListener('focusin', ()=>setExp(true));
      megaItem.addEventListener('focusout', e=>{ if(!megaItem.contains(e.relatedTarget)) setExp(false); });
      megaItem.addEventListener('mouseenter', ()=>setExp(true));
      megaItem.addEventListener('mouseleave', ()=>setExp(false));
    }

    // Region / market selector — sets the Shopify Market (PL→PLN, DE→EUR for the
    // demo) and reloads so prices re-render. Real market routing + currency are
    // owned by Shopify Markets; this only switches the prototype display.
    // German is disabled until the DE translation ships.
    document.querySelectorAll('[data-lang]:not([disabled])').forEach(b=>b.addEventListener('click',()=>{
      const mk = (b.getAttribute('data-lang')||'pl').toLowerCase();
      if(mk === (window.DZ_MARKET||'pl')){ closeMenu(); return; }
      try{ localStorage.setItem('dz_market', mk); }catch(e){}
      location.reload();
    }));
    const curMk = (window.DZ_MARKET||'pl').toUpperCase();
    document.querySelectorAll('[data-lang-label]').forEach(x=>x.textContent=curMk);
  }
  function closeMenu(){
    document.querySelector('.dz-mobile-menu').classList.remove('open');
    document.body.classList.remove('menu-open');
    document.body.style.overflow='';
    const burger = document.querySelector('[data-open-menu]');
    if(burger){ burger.setAttribute('aria-expanded','false'); burger.focus(); }
  }

  // ---- Homepage product carousel (mobile only) ----
  // The row is a plain grid on desktop and a scroll-snap carousel below 760px; the
  // arrows just drive scrollLeft, so touch swiping and the buttons stay in sync.
  function initCarousels(){
    document.querySelectorAll('[data-carousel]').forEach(initCarousel);
  }
  function initCarousel(scope){
    const row = scope.querySelector('[data-carousel-track]');
    if(!row || row.dataset.carouselBound) return;
    const items = [...row.children];
    if(items.length < 2) return;
    row.dataset.carouselBound = '1';
    const nav = scope.querySelector('[data-carousel-nav]');
    const prev = scope.querySelector('[data-carousel-prev]');
    const next = scope.querySelector('[data-carousel-next]');
    const dots = scope.querySelector('[data-carousel-dots]');
    if(dots && !dots.children.length) dots.innerHTML = items.map(()=>'<i></i>').join('');
    const mq = window.matchMedia('(max-width:760px)');
    const index = ()=> Math.round(row.scrollLeft / (row.clientWidth || 1));
    const sync = ()=>{
      const i = Math.min(items.length - 1, Math.max(0, index()));
      if(prev) prev.disabled = i === 0;
      if(next) next.disabled = i === items.length - 1;
      if(dots) [...dots.children].forEach((d,n)=>d.classList.toggle('is-on', n === i));
    };
    const go = dir => { row.scrollTo({ left: (index() + dir) * row.clientWidth, behavior:'smooth' }); };
    if(prev) prev.addEventListener('click', ()=>go(-1));
    if(next) next.addEventListener('click', ()=>go(1));
    let raf; row.addEventListener('scroll', ()=>{ cancelAnimationFrame(raf); raf = requestAnimationFrame(sync); }, {passive:true});
    const apply = ()=>{
      if(nav) nav.hidden = !mq.matches;
      if(prev) prev.hidden = !mq.matches;
      if(next) next.hidden = !mq.matches;
      if(mq.matches) sync();
    };
    mq.addEventListener ? mq.addEventListener('change', apply) : mq.addListener(apply);
    window.addEventListener('resize', sync, {passive:true});
    apply();
  }
  // ---- Cart drawer ----
  // The drawer markup is a Shopify section (sections/cart-drawer.liquid) and all
  // rendering / open / close / checkout is owned by window.dzCart (assets/dz-cart.js),
  // driven by Shopify /cart.js. This thin openCart only delegates the header
  // cart-icon click; it never builds markup, reads localStorage or runs a fake
  // checkout. (Root static site keeps its own cart — this is the theme copy only.)
  function openCart(){ if(window.dzCart) window.dzCart.open(); }

  // ---- Footer ----
  // Stage 2.3 (Shopify): the footer is rendered server-side by the Shopify footer
  // section. It has no JS-driven interactions today — the newsletter is a native
  // Shopify customer form and the cookies button calls window.dzOpenConsent (a
  // no-op until consent.js loads). This hook exists so future handlers can bind to
  // the existing markup without re-generating it.
  function wireExistingFooter(){ /* no footer interactions to wire today */ }

  function buildFooter(){
    // Prefer the server-rendered Shopify footer section when present.
    if(document.querySelector('.dz-footer')){ wireExistingFooter(); return; }
    const cols = [
      // Replacement strips link temporarily removed — product hidden from the storefront.
      {h:T('footer.col.shop'), links:[[T('footer.link.magnetic'),'produkt.html?id=magnetic-nose-band'],[T('footer.link.nasal'),'produkt.html?id=nasal-strips'],[T('footer.link.mouth'),'produkt.html?id=mouth-tape'],[T('footer.link.collagen'),'produkt.html?id=collagen-mouth-tape']]},
      {h:T('footer.col.company'), links:[[T('footer.link.aboutDatzzy'),'o-nas.html'],[T('footer.link.howItWorks'),'jak-to-dziala.html'],[T('footer.link.work'),'wspolpraca.html'],[T('footer.link.contact'),'kontakt.html']]},
      {h:T('footer.col.support'), links:[[T('footer.link.faq'),'index.html#faq'],[T('footer.link.shipping'),'dostawa-i-zwroty.html',true]]}
    ];
    const f = document.createElement('footer');
    f.className='dz-footer';
    f.innerHTML = `
      <div class="wrap">
        <div class="dz-foot-top">
          <div class="dz-foot-brand">
            <img src="${LOGO_LIGHT}" class="dz-foot-logo" alt="DATZZY" loading="lazy" decoding="async"/>
            <p>${T('footer.tagline')}</p>
            <a href="https://instagram.com/datzzy_official" class="dz-follow" target="_blank" rel="nofollow noopener" aria-label="Instagram DATZZY">
              <span class="dz-follow-ic">${socIcon('instagram')}</span>
              <span class="dz-follow-txt"><b>${T('footer.followUs')}</b><span>@datzzy_official</span></span>
            </a>
          </div>
          <div class="dz-foot-cols">
            ${cols.map(c=>`<div class="dz-foot-col"><div class="dz-foot-h">${c.h}</div>${c.links.map(l=>`<a href="${l[1]}"${l[2]?' rel="nofollow"':''}>${l[0]}</a>`).join('')}</div>`).join('')}
          </div>
          <div class="dz-foot-news">
            <div class="dz-foot-h">${T('footer.news.title')}</div>
            <p>${T('footer.news.text')}</p>
            <form class="dz-news-form" onsubmit="return false">
              <input type="email" placeholder="${T('footer.news.placeholder')}" aria-label="E-mail"/>
              <button class="btn btn-primary" aria-label="${T('footer.link.subscribe')}">${ICONS.arrow}</button>
            </form>
          </div>
        </div>
        <div class="dz-foot-bottom">
          <div class="dz-foot-meta">
            <span>${T('footer.rights')}</span>
            <span class="dz-foot-company">Sensation Poland Sp. z o.o. · ul. Krzyżówki 36/5 · 03-193 Warszawa · Poland</span>
          </div>
          <div class="dz-foot-legal"><a href="polityka-prywatnosci.html" rel="nofollow">${T('footer.privacy')}</a><a href="regulamin-sklepu.html" rel="nofollow">${T('footer.terms')}</a><button type="button" class="dz-foot-cookies" onclick="window.dzOpenConsent&&window.dzOpenConsent()">Ustawienia cookies</button></div>
        </div>
      </div>`;
    document.body.appendChild(f);
  }
  function socIcon(s){
    const m={
      instagram:'<rect width="20" height="20" x="2" y="2" rx="5.5"/><circle cx="12" cy="12" r="4.2"/><circle cx="17.4" cy="6.6" r="1.1" fill="currentColor" stroke="none"/>',
      youtube:'<rect x="3" y="6" width="18" height="12" rx="4"/><path d="M10.5 9.2v5.6l4.5-2.8z" fill="currentColor" stroke="none"/>',
      tiktok:'<path d="M14 4c.5 2.4 2 3.8 4 4v2.3c-1.5 0-2.9-.5-4-1.3v5.6a4.8 4.8 0 1 1-4.8-4.8c.3 0 .6 0 .9.1v2.4a2.4 2.4 0 1 0 1.7 2.3V4z"/>',
      mail:'<rect x="3" y="5" width="18" height="14" rx="3"/><path d="M4 7l8 6 8-6"/>'
    };
    return `<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">${m[s]}</svg>`;
  }

  // ---- Scroll reveal (rect-based: works in all environments, incl. preview) ----
  function initReveal(){
    const els = [...document.querySelectorAll('.reveal')];
    if(!els.length) return;
    function check(){
      const vh = window.innerHeight || document.documentElement.clientHeight;
      let remaining = false;
      els.forEach(e=>{
        if(e.classList.contains('in')) return;
        const r = e.getBoundingClientRect();
        if(r.top < vh*0.92 && r.bottom > 0) e.classList.add('in');
        else remaining = true;
      });
      return remaining;
    }
    // IntersectionObserver as a progressive enhancement (when it actually fires)
    if('IntersectionObserver' in window){
      const io = new IntersectionObserver((ents)=>{
        ents.forEach(e=>{ if(e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target);} });
      },{threshold:.06, rootMargin:'0px 0px -6% 0px'});
      els.forEach(e=>io.observe(e));
    }
    check();
    // Only attach the rect-based fallback where IntersectionObserver is missing —
    // otherwise this re-measured every .reveal element on every scroll event.
    if(!('IntersectionObserver' in window)){
      window.addEventListener('scroll', check, {passive:true});
      window.addEventListener('resize', check, {passive:true});
    }
    // Safety net: content must never stay hidden if no scroll occurs.
    setTimeout(()=>els.forEach(e=>e.classList.add('in')), 1200);
  }

  // ---- Accordions (FAQ + PDP safety) — shared behavior + ARIA ----
  // Centralizes the previously per-page toggle handlers. Buttons are native
  // <button>s, so keyboard (Enter/Space) already works; this adds the ARIA
  // contract (aria-expanded / aria-controls) and keeps the exact open/close
  // animation behavior. No visual change.
  function initAccordions(){
    const groups = [
      {q:'[data-faq] .faq-q', item:'.faq-item', panel:'.faq-a', idp:'faq'},
      {q:'[data-acc] .acc-q', item:'.acc-item', panel:'.acc-a', idp:'acc'}
    ];
    let n = 0;
    groups.forEach(g=>{
      document.querySelectorAll(g.q).forEach(q=>{
        const item = q.closest(g.item);
        const panel = item && item.querySelector(g.panel);
        if(!panel || q.dataset.accBound) return;
        q.dataset.accBound = '1';
        n++;
        const bid = q.id || (g.idp+'-btn-'+n);   q.id = bid;
        const pid = panel.id || (g.idp+'-panel-'+n); panel.id = pid;
        q.setAttribute('type','button');
        q.setAttribute('aria-controls', pid);
        q.setAttribute('aria-expanded', item.classList.contains('open')?'true':'false');
        panel.setAttribute('role','region');
        panel.setAttribute('aria-labelledby', bid);
        q.addEventListener('click', ()=>{
          const open = item.classList.contains('open');
          if(open){ item.classList.remove('open'); panel.style.maxHeight=null; q.setAttribute('aria-expanded','false'); }
          else    { item.classList.add('open');  panel.style.maxHeight=panel.scrollHeight+'px'; q.setAttribute('aria-expanded','true'); }
        });
      });
    });
  }

  /* ============================================================
     DATZZY — Motion system (premium, airflow-inspired)
     Performant props only (transform/opacity/filter). Everything
     decorative is gated behind prefers-reduced-motion. The CSS in
     datzzy.css carries the visual states; this wires up the
     observers, stagger indices, loader, parallax and count-ups.
     ============================================================ */
  const REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion:reduce)').matches;

  // Shared one-shot IntersectionObserver factory (adds a class, then unobserves).
  function onEnter(els, cb, opts){
    if(!els.length) return;
    if(!('IntersectionObserver' in window)){ els.forEach(e=>cb(e)); return; }
    const io = new IntersectionObserver((ents)=>{
      ents.forEach(en=>{ if(en.isIntersecting){ cb(en.target); io.unobserve(en.target); } });
    }, Object.assign({threshold:.12, rootMargin:'0px 0px -8% 0px'}, opts||{}));
    els.forEach(e=>io.observe(e));
  }

  /* ---- Hero text reveal (HeroTextReveal) ----
     Premium staggered blur-to-sharp entrance for hero copy, shared by every
     page (homepage, O nas, Współpraca, How It Works, collection, PDP).

     Implemented as a CSS keyframe animation (.hero-anim in datzzy.css), NOT a
     transition toggle, because keyframes replay deterministically on EVERY page
     load / mount — no JS state, no sessionStorage, no rAF race. `animation-fill:
     both` paints the hidden start frame immediately, so there is no flash of
     already-visible text. It is primed SYNCHRONOUSLY (before first paint, not on
     a scroll trigger) so above-the-fold hero text always animates on render.
     prefers-reduced-motion disables the keyframe in CSS, showing text at once. */
  function heroAnim(el, delay){
    if(!el) return;
    el.style.setProperty('--d', delay + 'ms');
    el.classList.add('hero-anim');
  }
  function primeHero(){
    // Homepage hero: headline → subheadline → CTAs → benefit items (one by one).
    const home = document.querySelector('.hero .hero-copy');
    if(home){
      heroAnim(home.querySelector('.h-display, h1'), 80);
      heroAnim(home.querySelector('.lead'), 300);
      heroAnim(home.querySelector('.hero-cta'), 500);
      const benefits = home.querySelector('.hero-benefits');
      if(benefits) [...benefits.children].forEach((ch,i)=> heroAnim(ch, 700 + i*120));
      return;
    }
    // Internal hero (O nas / Współpraca / How It Works / collection / PDP):
    // eyebrow → headline → supporting text → CTA.
    const host = document.querySelector('.about-hero .wrap, .ww-hero .wrap, .sci-hero .wrap, .pagehero .wrap, .pdp-hero');
    if(!host) return;
    [['.breadcrumb',40],['.eyebrow',120],['.h-display, h1',260],['.lead',440],['.hero-cta, .ww-cta',600]]
      .forEach(([sel,d])=> heroAnim(host.querySelector(sel), d));
  }
  // Restart the hero animation when the page is restored from the back/forward
  // cache (pageshow.persisted) — otherwise a returning visitor sees it static.
  function replayHero(){
    document.querySelectorAll('.hero-anim').forEach(el=>{
      el.style.animation = 'none'; void el.offsetWidth; el.style.animation = '';
    });
  }

  // 3/6/9/10/15 · Stagger groups (cards translate; icon groups scale+blur).
  function initStagger(){
    if(REDUCED) return;
    const GROUPS = [
      // card / grid groups → translateY fade
      {sel:'.goal-grid', step:100}, {sel:'.pillars', step:100}, {sel:'.ecorow', step:90},
      {sel:'.stat-cards', step:90}, {sel:'.dz-foot-cols', step:80},
      {sel:'.hiw-mini', step:90}, {sel:'.edu-list', step:90},
      // Work With Us (B2B), Homepage UGC, Education hub
      {sel:'.metric-grid', step:80}, {sel:'.proc', step:90}, {sel:'.ben-grid', step:80},
      {sel:'.retail-checks', step:70}, {sel:'.ugc-grid', step:80}, {sel:'.article-grid', step:80},
      // icon-led groups → scale + blur pop  (.hero-benefits is handled by
      // primeHero so it follows the headline/CTA timeline on load)
      {sel:'.benefit-strip', step:80, pop:true},
      {sel:'.why-grid', step:80, pop:true}, {sel:'.sys-split .grid', step:90, pop:true},
      {sel:'.chip-row', step:55, pop:true}
    ];
    GROUPS.forEach(g=>{
      document.querySelectorAll(g.sel).forEach(c=>{
        const kids = [...c.children];
        if(kids.length < 2) return;
        c.classList.add('dz-stagger', 'in'); // 'in' neutralises any parent .reveal hide
        if(g.pop) c.classList.add('dz-stagger-pop');
        c.style.setProperty('--step', g.step+'ms');
        kids.forEach((ch,i)=>{ ch.classList.add('dz-stg'); ch.style.setProperty('--i', i); });
        onEnter([c], el=>el.classList.add('is-in'));
      });
    });
  }

  // 5 · Extremely subtle decorative parallax (airflow elements only — never
  // touches content photography). rAF-throttled, tiny amplitude.
  function initParallax(){
    if(REDUCED) return;
    const items = [...document.querySelectorAll('.hero-orb, .why-mark')].map(el=>({el, amp:14}));
    if(!items.length) return;
    let ticking=false;
    function update(){
      ticking=false;
      const vh = window.innerHeight;
      items.forEach(it=>{
        const r = it.el.getBoundingClientRect();
        if(r.bottom < 0 || r.top > vh) return;
        const prog = (r.top + r.height/2 - vh/2) / vh; // -0.5..0.5 around centre
        // Use the independent `translate` property so we never clobber the
        // element's base `transform` (e.g. translateY(-50%) centring).
        it.el.style.translate = `0 ${(prog*it.amp).toFixed(1)}px`;
      });
    }
    function onScroll(){ if(!ticking){ ticking=true; requestAnimationFrame(update); } }
    window.addEventListener('scroll', onScroll, {passive:true});
    window.addEventListener('resize', onScroll, {passive:true});
    update();
  }

  // 11 · Count-up for statistic cards. Animates a single leading number while
  // preserving any prefix/suffix (×, %, h). Skips ranges (e.g. "53–56%").
  function initCountUp(){
    if(REDUCED) return;
    const els = [...document.querySelectorAll('.stat-num')].filter(el=>{
      const t = el.textContent.trim();
      if(/\d[–-]\d/.test(t)) return false;            // range → leave as-is
      const m = t.match(/^(\D*)(\d+(?:\.\d+)?)(\D*)$/); // prefix? number suffix?
      if(!m) return false;
      el._cu = {pre:m[1], end:parseFloat(m[2]), dec:(m[2].split('.')[1]||'').length, suf:m[3]};
      el.textContent = m[1] + '0' + m[3];
      return true;
    });
    onEnter(els, el=>{
      const {pre,end,dec,suf} = el._cu; const dur=900, t0=performance.now();
      (function step(now){
        const p = Math.min(1,(now-t0)/dur);
        const e = 1-Math.pow(1-p,3); // easeOutCubic
        el.textContent = pre + (end*e).toFixed(dec) + suf;
        if(p<1) requestAnimationFrame(step); else el.textContent = pre+end.toFixed(dec)+suf;
      })(performance.now());
    });
  }

  // 1/2 · Storytelling section reveal — sequences a section's key elements
  // (title → text → image → checklist/benefit items → CTA) with the same
  // blur-to-sharp language as the heroes, triggered when the section enters view.
  // `entries`: ordered [{el, fade}] — fade:true = opacity/blur only (for bleed
  // images that must not translate), else translateY + blur.
  function revealSequence(trigger, block, entries, step){
    if(REDUCED || !trigger) return;
    if(block) block.classList.add('in'); // neutralise the block-level .reveal so it doesn't double-fade
    const list = [];
    entries.forEach(e=>{
      if(!e.el) return;
      e.el.classList.add(e.fade ? 'reveal-fade' : 'reveal-blur');
      e.el.style.transitionDelay = (list.length * step) + 'ms';
      list.push(e.el);
    });
    onEnter([trigger], ()=>list.forEach(el=>el.classList.add('in')), {threshold:.18});
  }

  function initStoryReveals(){
    if(REDUCED) return;
    // Homepage — Science ("Nauka")
    const sci = document.querySelector('.sci-editorial');
    if(sci){
      const body = sci.querySelector('.sci-body');
      revealSequence(sci, sci.querySelector('.reveal'), [
        {el: sci.querySelector('.sci-bleed')},
        {el: body && body.querySelector('.eyebrow')},
        {el: body && body.querySelector('h2')},
        {el: body && body.querySelector('.lead')},
        ...[...(body ? body.querySelectorAll('.sci-points li') : [])].map(el=>({el})),
        {el: body && body.querySelector('.btn')}
      ], 110);
    }
    // Homepage — Subscription
    const sub = document.querySelector('[data-screen-label="Home / Subscription"]');
    if(sub){
      const inner = sub.querySelector('.subband-inner > div') || sub;
      revealSequence(sub, sub.querySelector('.reveal'), [
        {el: sub.querySelector('.sub-bleed'), fade:true}, // full-bleed image → no translate
        {el: inner.querySelector('.tag')},
        {el: inner.querySelector('h2')},
        ...[...inner.querySelectorAll('.sub-list li')].map(el=>({el})),
        {el: inner.querySelector('.btn')}
      ], 100);
    }
  }

  // 4 · About "Gdzie oddychamy" — scroll-linked cinematic map zoom that gradually
  // pushes in on Poland/Germany (the highlighted countries) as the section is read,
  // so by the end they dominate the visible frame. Scale only (no translate → no
  // layout movement, no parallax sickness).
  function initMapZoom(){
    if(REDUCED) return;
    const img = document.querySelector('#markets .market-vis img');
    if(!img) return;
    const section = img.closest('section') || document.getElementById('markets');
    img.classList.add('dz-mapzoom');
    // Poland + Germany (the bright-blue pair) sit ~centre, a touch above the middle.
    img.style.transformOrigin = '49% 45%';
    let ticking = false;
    function update(){
      ticking = false;
      const r = section.getBoundingClientRect();
      const vh = window.innerHeight || document.documentElement.clientHeight;
      let p = (vh - r.top) / (vh + r.height); // 0 entering bottom → 1 leaving top
      p = Math.max(0, Math.min(1, p));
      const eased = p * p * (3 - 2 * p); // smoothstep — gentle ease in/out, never jerky
      img.style.scale = (1 + eased * 0.85).toFixed(4); // up to +85% → Central Europe dominates
    }
    function onScroll(){ if(!ticking){ ticking = true; requestAnimationFrame(update); } }
    window.addEventListener('scroll', onScroll, {passive:true});
    window.addEventListener('resize', onScroll, {passive:true});
    update();
  }

  // DatzzyHeroVideo — reusable hero background video for any <video data-hero-video>.
  // Plays once (no loop) and holds its final frame. Fades in only once the first
  // frame has decoded, so there is never a flash of an empty/partial frame and no
  // poster/first-frame mismatch. prefers-reduced-motion → stays paused on frame 1
  // (a static still). Runs regardless of REDUCED, so it is NOT inside initMotion.
  function initHeroVideo(){
    const vids = document.querySelectorAll('video[data-hero-video]');
    vids.forEach(v=>{
      v.muted = true;        // required for muted autoplay / programmatic play()
      v.playsInline = true;
      v.loop = false;        // belt-and-braces: play once, hold final frame

      // Fade in as soon as the first frame is available (readyState >= 2).
      const reveal = ()=> v.classList.add('is-ready');
      if(v.readyState >= 2) reveal();
      else { v.addEventListener('loadeddata', reveal, {once:true});
             v.addEventListener('canplay', reveal, {once:true}); }

      if(REDUCED){
        // No motion: don't play. Show the first frame as a static still.
        v.autoplay = false; v.removeAttribute('autoplay');
        const hold = ()=>{ try{ v.pause(); v.currentTime = 0; }catch(e){} };
        if(v.readyState >= 1) hold();
        else v.addEventListener('loadedmetadata', hold, {once:true});
        return;
      }
      // Play through exactly once. The `autoplay` attribute already covers the
      // pre-JS path; this is a fallback for browsers that blocked attribute autoplay.
      const play = ()=>{ const p = v.play(); if(p && p.catch) p.catch(()=>{}); };
      if(v.readyState >= 2) play();
      else v.addEventListener('canplay', play, {once:true});
    });
  }

  // LoopVideo — reusable looping background/section visual for <video data-loop-video>.
  // Muted autoplay + smooth loop; plays only while in view and pauses off-screen for
  // performance. Fades in once the first frame decodes (no mismatched-poster flash).
  // prefers-reduced-motion → stays paused on the first frame (a static still).
  // LazyPoster — a <video poster> is fetched eagerly by the browser even when the
  // element carries preload="none", and it ignores loading="lazy". On the homepage
  // that meant ~150 KB of below-the-fold UGC posters competing with the hero image
  // for bandwidth before it had finished. Pages therefore ship data-poster, and we
  // promote it to the real poster attribute only as the video nears the viewport.
  // No IntersectionObserver (very old browsers) → apply immediately, as before.
  function initLazyPoster(){
    const vids = document.querySelectorAll('video[data-poster]');
    if(!vids.length) return;
    const apply = v => {
      if(!v.dataset.poster) return;
      v.setAttribute('poster', v.dataset.poster);
      v.removeAttribute('data-poster');
    };
    if(!('IntersectionObserver' in window)){ vids.forEach(apply); return; }
    const io = new IntersectionObserver((ents, obs)=>{
      ents.forEach(e=>{ if(e.isIntersecting){ apply(e.target); obs.unobserve(e.target); } });
    }, {rootMargin:'400px'});
    vids.forEach(v=> io.observe(v));
  }

  function initLoopVideo(){
    const vids = document.querySelectorAll('video[data-loop-video]');
    vids.forEach(v=>{
      v.muted = true; v.playsInline = true; v.loop = true;

      const reveal = ()=> v.classList.add('is-ready');
      if(v.readyState >= 2) reveal();
      else { v.addEventListener('loadeddata', reveal, {once:true});
             v.addEventListener('canplay', reveal, {once:true}); }

      if(REDUCED){
        v.autoplay = false; v.removeAttribute('autoplay'); v.loop = false;
        const hold = ()=>{ try{ v.pause(); v.currentTime = 0; }catch(e){} };
        if(v.readyState >= 1) hold(); else v.addEventListener('loadedmetadata', hold, {once:true});
        return;
      }
      const play = ()=>{ const p = v.play(); if(p && p.catch) p.catch(()=>{}); };
      if('IntersectionObserver' in window){
        const io = new IntersectionObserver((ents)=>{
          ents.forEach(e=> e.isIntersecting ? play() : v.pause());
        }, {threshold:.2});
        io.observe(v);
      } else { play(); }
    });
  }

  // ScrollScrubVideo — ties <video data-scrub-video>'s currentTime DIRECTLY to how
  // far its section has scrolled (currentTime = duration * progress). No autoplay,
  // no loop, no time-based playback: the frame only moves when the user scrolls and
  // reverses on scroll-up. Uses "seek chaining" (re-seek to the latest target only
  // after the previous seek finishes) so we never flood the decoder, stay responsive,
  // and always converge to the current scroll position — no easing that could hide
  // sub-frame movement. prefers-reduced-motion → no scrubbing; poster still shows.
  function initScrubVideo(){
    const vids = document.querySelectorAll('video[data-scrub-video]');
    vids.forEach(v=>{
      v.muted = true; v.playsInline = true; v.loop = false; v.autoplay = false;
      try{ v.pause(); }catch(e){}
      if(REDUCED) return; // poster stands in; never scrub

      const section = v.closest('section') || v.parentElement;
      let dur = 0, target = 0, seeking = false, raf = 0;

      function progress(){
        const r = section.getBoundingClientRect();
        const vh = window.innerHeight || document.documentElement.clientHeight;
        // ScrollTrigger-style: start ≈ section top at 80% vp, end ≈ bottom at 20% vp.
        const p = (vh * 0.80 - r.top) / (vh * 0.60 + r.height);
        return Math.max(0, Math.min(1, p));
      }
      function apply(){
        raf = 0;
        if(!dur || seeking) return;                  // wait for the in-flight seek
        if(Math.abs(v.currentTime - target) > 0.02){
          seeking = true;
          try{ v.currentTime = target; }catch(e){ seeking = false; }
        }
      }
      function schedule(){ if(!raf) raf = requestAnimationFrame(apply); }
      // When a seek completes, if the scroll target has moved on, chase it.
      v.addEventListener('seeked', ()=>{ seeking = false;
        if(dur && Math.abs(v.currentTime - target) > 0.02) schedule(); });
      function onScroll(){ if(dur){ target = progress() * dur; schedule(); } }

      const ready = ()=>{
        dur = v.duration || 0;
        if(!dur || !isFinite(dur)) return;
        target = progress() * dur;                   // first frame matches scroll pos
        try{ v.currentTime = target; }catch(e){}
      };
      if(v.readyState >= 1 && v.duration) ready();
      else { v.addEventListener('loadedmetadata', ready, {once:true});
             v.addEventListener('canplay', ready, {once:true}); }

      window.addEventListener('scroll', onScroll, {passive:true});
      window.addEventListener('resize', ()=>{ ready(); onScroll(); }, {passive:true});
    });
  }

  function initMotion(){
    // Enables all CSS-gated entrance/hover motion. Skipped under reduced motion
    // so nothing is ever left hidden or animated.
    if(!REDUCED) document.documentElement.classList.add('dz-motion');
    initStagger();
    initStoryReveals();
    initParallax();
    initMapZoom();
    initCountUp();
  }

  /* ============================================================
     Temporary pre-launch mode: store disabled until Shopify launch.
     ------------------------------------------------------------
     Turns every purchasing control across the site into a disabled
     "Sklep wkrótce" state and hides prices (via the body class + CSS).
     Runtime-only: the source markup is unchanged, so flipping PRELAUNCH
     back to false fully restores the store. A MutationObserver re-applies
     the state to controls rendered later (collection filters re-render the
     grid, the PDP injects related products, etc.). */
  function initPrelaunch(){
    if(!PRELAUNCH) return;
    document.body.classList.add('dz-prelaunch');
    // Every purchase / checkout / shop CTA on any page.
    const SEL = '[data-addcart],[data-sticky-add],[data-checkout],.btn-add,.bundle-cta,.pdp-add,.pdp-pay,.rel-add,.dz-shop';
    const isIconOnly = el => el.classList.contains('rel-add'); // compact icon buttons keep their glyph
    function markSoon(el){
      if(el.dataset.dzSoon) return;
      el.dataset.dzSoon = '1';
      el.classList.add('dz-soon');
      el.classList.remove('btn-primary','btn-dark');
      el.setAttribute('aria-disabled','true');
      if(el.tagName === 'BUTTON') el.disabled = true;
      if(!isIconOnly(el)) el.textContent = SOON_LABEL;
      // Belt-and-braces: swallow clicks even if a page re-binds a handler.
      el.addEventListener('click', e=>{ e.preventDefault(); e.stopPropagation(); }, true);
    }
    const sweep = ()=> document.querySelectorAll(SEL).forEach(markSoon);
    sweep();
    // Re-sweep after dynamic renders (rAF-debounced).
    let scheduled = false;
    const mo = new MutationObserver(()=>{
      if(scheduled) return; scheduled = true;
      requestAnimationFrame(()=>{ scheduled = false; sweep(); });
    });
    mo.observe(document.body, {childList:true, subtree:true});
  }

  function dzInit(){
    if(!document.body.hasAttribute('data-no-chrome')){
      buildHeader(); buildFooter();
    }
    initPrelaunch();
    initReveal();
    initAccordions();
    initCarousels();
    initMotion();
    initHeroVideo();
    initLazyPoster();
    initLoopVideo();
    initScrubVideo();
  }
  // Prime the hero text reveal SYNCHRONOUSLY (before first paint) so above-the-fold
  // hero copy always animates on render — and on every refresh, with no flash.
  // The hero markup sits above this script in the body, so it already exists here.
  primeHero();
  window.addEventListener('pageshow', e=>{ if(e.persisted) replayHero(); });

  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded', dzInit);
  else dzInit();

  // Shopify Theme Editor (Stage 2.4): when a homepage section is added, edited,
  // reordered or reloaded in design mode, re-run the idempotent interaction inits so
  // animations / FAQ accordions / media wiring bind to the new markup. Global chrome
  // (header/footer/cart) is NOT rebuilt — those bind to server markup and guard against
  // double-binding. Per-section carousels self-wire in their section script (guarded).
  // initAccordions guards via data-acc-bound; the rest are safe to call again. Design
  // mode only, so live visitors never run this.
  if(window.Shopify && window.Shopify.designMode){
    document.addEventListener('shopify:section:load', function(){
      initReveal(); initAccordions(); initMotion();
      initHeroVideo(); initLazyPoster(); initLoopVideo(); initScrubVideo();
      primeHero();
    });
  }
})();
